import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { FLOW } from 'app/model/adapters/dataflow/IDataflow';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { SurrogateKeyTransformation } from '../../../dataflow/surrogatekeytransformation';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SurrogateKeyTransformation),
    asynchronous: true
})
export class SurrogateKeyTransformationAdapter extends TransformationAdapter<SurrogateKeyTransformation> {
    public async getDslScript(surrogateKeyTransformation: SurrogateKeyTransformation): Promise<string> {
        const column = surrogateKeyTransformation.keyColumn;
        const outputColumn = `output(${column.serializableColumnName} as ${column.dataFlowColumnType.typeString})`;
        const startAtConfig = `startAt: ${surrogateKeyTransformation.startAtValue}L`;
        const stepValueConfig = `stepValue: ${surrogateKeyTransformation.stepValue}L`;
        const enableCdcConfig = `enableCdc: ${surrogateKeyTransformation.enableCdc}`;

        const partition = TransformationAdapter.getPartitionDslScript(surrogateKeyTransformation);

        const knownProps = [
            outputColumn,
            startAtConfig,
            stepValueConfig,
            partition,
            surrogateKeyTransformation.showEnableCdc() && surrogateKeyTransformation.enableCdc ? enableCdcConfig : null
        ]
            .filter((c) => !!c)
            .join(',\n\t');
        const unknownProps = this._getUnknownProps(surrogateKeyTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(surrogateKeyTransformation)}` +
            ` keyGenerate(${transformationData}) ${FLOW} ${this._getOutputStreams(surrogateKeyTransformation)}`
        );
    }
}
